export type MobileExperimentArm = 'control' | 'video-360p30' | 'audio-64k-mono' | 'combined';
export interface MobileExperimentLimits {
  maxWidth?: number;
  maxHeight?: number;
  maxFramerate?: number;
  maxBitrateBps?: number;
  audioMaxBitrateBps?: number;
  audioStereo?: boolean;
}

/** Opt-in session configuration. A new control session gets no overrides. */
export class MobileQualityExperiment {
  constructor(private readonly options: { arm: MobileExperimentArm }) {}

  limits(input: { isMobile: boolean; constrainedTrial: boolean;
    currentMaxBitrateBps: number; hardCutMaxBitrateBps: number }): MobileExperimentLimits {
    if (!input.isMobile || !input.constrainedTrial || this.options.arm === 'control') return {};
    const limits: MobileExperimentLimits = {};
    if (this.options.arm === 'video-360p30' || this.options.arm === 'combined') {
      if (![input.currentMaxBitrateBps, input.hardCutMaxBitrateBps].every(value => Number.isFinite(value) && value > 0)) return {};
      Object.assign(limits, { maxWidth: 640, maxHeight: 360, maxFramerate: 30,
        maxBitrateBps: Math.min(input.currentMaxBitrateBps, input.hardCutMaxBitrateBps) });
    }
    if (this.options.arm === 'audio-64k-mono' || this.options.arm === 'combined') {
      limits.audioMaxBitrateBps = 64_000;
      limits.audioStereo = false;
    }
    return limits;
  }
}
